import {FC, useEffect, useState} from 'react'
import FormPasswrod from 'thesis-and-dissertations/pages/Profile/FormPassword'
import {Link, useNavigate} from 'react-router-dom'

import Api from '../../../../thesis-and-dissertations/helpers/api'

import ComingSoonModal from 'pana/pages/MyPana/ComingSoonModal'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import AlertModal from 'pana/pages/Home/AlertModal'
import {clearLocalStorageExcept} from 'thesis-and-dissertations/helpers/helper'
const api = new Api()

const HeaderUserMenu: FC = () => {
  const navigate = useNavigate()
  const [user, setUser] = useState<any>(null)
  const [show, setShow] = useState(false)
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem('kt-auth-react-v') || '')
    setUser(data)
  }, [])

  const toggle = () => {
    setShow(!show)
  }

  const handleShowModal = (e: any) => {
    setShow(e)
  }

  const handleCloseAlert = (type: boolean) => {
    setShowAlertModal(type)
  }

  const handleSwitchPage = (type: any) => {
    switch (type) {
      case 'pana':
        localStorage.setItem('alumniPage', 'talenta')
        navigate('/talenta-dashboard')
        window.location.reload()
        return
      default:
        checkPana()
    }
  }

  const handleCurrentPage = () => {
    switch (localStorage.getItem('alumniPage')) {
      case 'pana':
        return 'Switch Page Lowongan Pekerjaan'
      case 'talenta':
        return 'Switch Page PANA'
    }
  }

  const checkPana = () => {
    api
      .checkPana()
      .then((response: any) => {
        const {data} = response.data

        if (!data?.status) {
          setShowAlertModal(true)
          return
        }

        localStorage.setItem('alumniPage', 'pana')
        navigate('/pana-beranda')
        window.location.reload()
      })
      .catch((error: any) => {
        handleApiError(error)
      })
  }

  return (
    <>
      {/* saat pana sudah rilis aktifkan AlertModal */}
      <AlertModal showAlertModal={showAlertModal} handleCloseAlert={handleCloseAlert} />
      {/* <ComingSoonModal showAlertModal={showAlertModal} handleCloseAlert={handleCloseAlert} /> */}

      <FormPasswrod showModal={show} handleShowModal={handleShowModal} />

      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
        data-kt-menu='true'
      >
        <div className='menu-item px-3'>
          <div className='menu-content d-flex align-items-center px-3'>
            <div className='symbol symbol-50px me-5'>
              {/* <img alt='Logo' src={require('../../../../assets/img/avatar.jpg')} /> */}
            </div>

            <div className='d-flex flex-column'>
              <div className='fw-bolder d-flex align-items-center fs-5'>
                {/* {currentUser?.first_name} {currentUser?.first_name} */}
                Halo, {user?.users_firstname}
              </div>
              <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
                {user?.email}
              </a>
              <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
                {user?.role_name}
              </a>
            </div>
          </div>
        </div>

        {localStorage.getItem('alumniPage') ? (
          <>
            <div className='separator my-2'></div>
            <div className='menu-item px-5'>
              <a
                onClick={() => handleSwitchPage(localStorage.getItem('alumniPage'))}
                className='menu-link px-5'
              >
                {handleCurrentPage()}
              </a>
            </div>
          </>
        ) : null}

        <div className='separator my-2'></div>

        <div className='menu-item px-5'>
          <a onClick={toggle} className='menu-link px-5'>
            Ubah Password
          </a>
        </div>

        <div className='menu-item px-5'>
          <a
            onClick={() => {
              clearLocalStorageExcept([])
              navigate('/')
              window.location.reload()
            }}
            className='menu-link px-5'
          >
            Sign Out
          </a>
        </div>
      </div>
    </>
  )
}

export {HeaderUserMenu}
